import { Partner } from "../components/Partner";

export function PartnerPage() {
  return <Partner />;
}
